import { Button, Card, Descriptions, Flex, Tag } from "antd";
import { useNavigate, useParams } from "react-router";
import { historyLogService } from "../../services/history-log.service";
import { format } from "date-fns";
import { useGetDetailApi } from "../../hooks/useApi";

export default function HistoryLogForm() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data } = useGetDetailApi({
    id,
    serviceFn: historyLogService.getById,
    queryKey: ["historyLog"],
  });

  return (
    <>
      <Card
        title={(id ? "Detail" : "Tambah") + " Data"}
        actions={[
          <Flex key={"1"} style={{ paddingRight: 24 }} justify="flex-end">
            <Button
              onClick={() => navigate("/history-log")}
              variant="outlined"
              color="primary"
            >
              Kembali
            </Button>
          </Flex>,
        ]}
      >
        <Descriptions
          bordered
          size="small"
          column={1}
          labelStyle={{ width: 210 }}
          items={[
            {
              label: "Modul",
              children: data?.module,
            },
            {
              label: "Aksi",
              children: (() => {
                switch (data?.action) {
                  case "CREATE":
                    return <Tag color="success">{data?.action}</Tag>;
                  case "UPDATE":
                    return <Tag color="blue">{data?.action}</Tag>;
                  case "DELETE":
                    return <Tag color="red">{data?.action}</Tag>;
                }
              })(),
            },
            {
              label: "Data Awal",
              children: <pre>{JSON.stringify(data?.oldData, null, 2)}</pre>,
            },
            {
              label: "Data Perubahan",
              children: <pre>{JSON.stringify(data?.newData, null, 2)}</pre>,
            },
            {
              label: "Updated By",
              children: `${data?.actorName} - ${
                data?.createdAt &&
                format(new Date(data?.createdAt), "EEEE, dd/MM/yyyy HH:mm")
              }`,
            },
          ]}
        />
      </Card>
    </>
  );
}
